module.exports = __webpack_public_path__ + "img/video-screen-non-logged-se.436d4043.png";